import SearchResult from '@/services/models/searchResult'
import { request } from '@/utils/request'
import { EventBus } from '@/utils/eventBus'

export default {
    async list(categories) {
        let content = await request.get(`/api/manage/tasks`, { categories })

        let entities = {}
        content.entities.forEach(e => {
            var typed = entities[e.type] || (entities[e.type] = [])
            typed[e.id] = new SearchResult(e)
        })

        content.tasks.forEach(t => (t.entity = entities[t.primaryEntityType]?.[t.primaryEntityId]))
        content.categories = [...new Set(content.categories.map(c => c.category))].sort()

        return content
    },
    listByEntityTypeAndEntityId(entityType, entityId) {
        return request.get(`/api/manage/tasks/entities/${entityType}/${entityId}`)
    },
    async complete(task) {
        await request.delete(`/api/manage/tasks/${task.id}`)
        EventBus.publish('task-completed', task)
    },
}
